export default {
	title: 'safety',
	components: [
		{
			title: 'voltage_protection',
			component: 'cb_voltage_protection',
		},
	],
};
